import { StackView, Box, Avatar, Text, Icon, Badge } from '@planningcenter/tapestry-react';
import React from 'react';
import colors from '../vendor/topbar/colors.js';

const Person = ({ person }) => {
    const Comp = person.child ? Child : Adult;
    return React.createElement(Comp, { person: person });
};
const Adult = ({ person }) => (React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 1 },
    React.createElement(Avatar, { src: person.avatar, size: "lg" }),
    React.createElement(StackView, { alignment: "start", spacing: 0.25 },
        React.createElement(Text, { truncate: true }, person.name),
        person.badges.length > 0 && (React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 0.5 }, person.badges.map(({ title }) => (React.createElement(Badge, { key: title, size: "xs" }, title))))))));
const Child = ({ person }) => (React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 1 },
    React.createElement(Box, { opacity: 0.5 },
        React.createElement(Avatar, { src: person.avatar, size: "lg" })),
    React.createElement(StackView, null,
        React.createElement(Text, { color: "foreground", opacity: 0.75, truncate: true }, person.name),
        React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 0.5 },
            React.createElement(Icon, { name: "general.shieldExclamation", color: colors.warning49 }),
            React.createElement(Text, { color: colors.warning20, size: 5 }, "Not eligible to chat")))));

export { Person };
//# sourceMappingURL=person_list_item.js.map
